export default "__VITE_ASSET__CODj0EVq__"